import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { useCreateDemoOrder } from '../../../../../demos/hooks/use-create-demo-order';
import Global from '../../../../../store/global-selectors';
import { openExistingDemoOrder } from '../../../../../store/demos/demos.actions';
import { DEFAULT_DEMO_FULFILLMENT_PLAN_ID } from '../../../../../demos/demo-orders';
import { messages } from '../messages';
import { Segment } from '../../../../../services/analytics-services/segment';
import { CREATE_DEMO_ORDER_BUTTON_CLICKED } from '../../../../../constants/analytics-events';
import { EventSourceStrings } from '../../../../../tracking/tracking-constants';

export const CreateDemoOrderButton = ({ setIsLoading }) => {
  const createDemoOrder = useCreateDemoOrder();
  const demoFulfillmentPlanId = useSelector(Global.selectSellerDemoFulfillmentPlanId);
  const buttonText = demoFulfillmentPlanId > 0 ? messages.openDemoOrder : messages.demoOrderButton;
  const sellerId = useSelector(Global.selectSellerSellerId);
  const dispatch = useDispatch();
  const onButtonClick = () => {
    const isExistingOrder = demoFulfillmentPlanId !== DEFAULT_DEMO_FULFILLMENT_PLAN_ID;

    Segment.trackEvent(CREATE_DEMO_ORDER_BUTTON_CLICKED, {
      source: EventSourceStrings.HOME_PAGE_FEED_CARD,
      isExistingOrder,
      sellerId,
    });

    if (isExistingOrder) {
      dispatch(openExistingDemoOrder());
    } else {
      setIsLoading(true);
      createDemoOrder();
    }
  };
  return (
    <Button onClick={onButtonClick} theme='tertiary'>
      <FormattedMessage {...buttonText} />
    </Button>
  );
};
